import React, {useState} from 'react'
import type {IProductSwitcherCategory} from '../../../../types/userTypes'
import {ReactComponent as UnLock} from '../../../../assets/Icons/Unlock.svg'
import {ReactComponent as RightArrow} from '../../../../assets/Icons/RightArrow.svg'
import {ProductSwitcherMenuHoveredItem} from '../menu-hovered-item/ProductSwitcherMenuHoveredItem'
import styles from '../ProductSwitcher.module.scss'

interface IProductSwitcherMenuItemProps {
  menuItem: IProductSwitcherCategory
}

export const ProductSwitcherMenuItem = ({
  menuItem,
}: IProductSwitcherMenuItemProps): React.JSX.Element => {
  const [, setHovered] = useState<boolean>(false)

  return (
    <li
      className={styles.item}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className={styles.itemContent}>
        <div className={styles.itemContentBlock}>
          <div>
            <img
              src={menuItem?.logo}
              alt={menuItem?.name}
              width={40}
              height={40}
            />
          </div>
          <div className={styles.itemContentNameDesc}>
            <p className={styles.itemName}>{menuItem?.name}</p>
            <p className={styles.itemDesc}>{menuItem?.desc}</p>
          </div>
        </div>
        {menuItem?.active ? (
          <RightArrow width={6} className={styles.itemArrow} />
        ) : (
          <UnLock />
        )}
      </div>

      {menuItem?.active && (
        <ul className={styles.hoverItem}>
          {menuItem?.products?.map((item, key) => {
            return (
              <ProductSwitcherMenuHoveredItem
                parentItem={menuItem}
                item={item}
                key={key}
              />
            )
          })}
        </ul>
      )}
    </li>
  )
}
